import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import cartService from '../services/cartService';
import { useAuth } from './AuthContext';

const CartContext = createContext();

export const useCart = () => {
    const context = useContext(CartContext);
    if (!context) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};

export const CartProvider = ({ children }) => {
    const [cartCount, setCartCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const { isAuthenticated } = useAuth();

    const fetchCartCount = useCallback(async () => {
        try {
            setLoading(true);
            const response = await cartService.getCart();
            if (response.success) {
                setCartCount(response.data.itemCount || 0);
            }
        } catch (error) {
            console.error('CartContext - Failed to fetch cart count:', error);
            setCartCount(0);
        } finally {
            setLoading(false);
        }
    }, []);

    const refreshCart = useCallback(() => {
        fetchCartCount();
    }, [fetchCartCount]);

    useEffect(() => {
        fetchCartCount();
    }, [fetchCartCount]);

    const value = {
        cartCount,
        setCartCount,
        loading,
        refreshCart
    };

    return (
        <CartContext.Provider value={value}>
            {children}
        </CartContext.Provider>
    );
};
